export default __webpack_public_path__ + "images/d9b02a8044aa5c05fe339d7c10ee70ec-spa.webp";